// extracted by mini-css-extract-plugin
export default {"ChartInfo":"chart-info_ChartInfo__WUbhy"};